<div class="loading-overlay" [ngClass]="{ 'is-loading': isLoading }"></div>

<!-- item loading containers -->
<div *ngIf="!pageReady" class="section">
  <div class="container">
    <div class="columns is-multiline is-mobile">
      <!-- Heder -->
      <div class="column is-12">
        <div class="content placeholder">
          <p class="title">&nbsp;</p>
          <p class="subtitle">&nbsp;</p>
        </div>
      </div>
      <!-- Items -->
      <div
        class="column is-12-mobile is-6-tablet is-4-desktop"
        *ngFor="let x of [0, 1, 2, 4]"
      >
        <div class="card elevation-1">
          <div class="">
            <div class="placeholder" style="height: 40px;"></div>
            <div class="placeholder media" style="height: 96px;"></div>
            <div class="placeholder" style="height: 40px;"></div>
            <div class="placeholder media" style="height: 96px;"></div>
            <div class="columns is-mobile">
              <div class="column">
                <div class="button full-width placeholder">&nbsp;</div>
              </div>
              <div class="column">
                <div class="button full-width placeholder">&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Items -->
<section class="section" *ngIf="pageReady">
  <div class="container">
    <div class="columns is-multiline is-mobile">
      <!-- Header -->
      <div class="column is-12-mobile is-10-tablet is-offset-1-tablet">
        <div class="content">
          <p class="title is-capitalized">Hello {{ orderInfo.FIRST_NAME }},</p>
        </div>
      </div>
      <!-- Subs -->
      <div
        class="column is-12-mobile is-10-tablet is-offset-1-tablet"
        *ngIf="orderSubs.length > 0 || 
        (retailStore.isCustomerChoiceEnabled && 
        (custSubs.length > 0 || backupSubs.length > 0))"
      >
        <div class="columns is-multiline is-mobile" style="display: block;">
          <!-- Header -->
          <div class="column is-12">
            <div class="content">
              <p class="subtitle">Please review our substitutions below.</p>
            </div>
          </div>
          <!-- List -->
          <div class="column is-12-mobile is-6-tablet" *ngIf="orderSubs.length > 0">
            <div *ngFor="let orderSub of orderSubs">
              <div class="card elevation-1">
                <div style="padding-bottom: 1rem;">
                  <h5 [ngSwitch]="orderSub.oldItem.MWG_UPC_NUM === ''">
                    <div *ngSwitchCase="true">You entered...</div>
                    <div *ngSwitchDefault>We did not have...</div>
                  </h5>
                </div>
                <app-product-list
                  [item]="orderSub.oldItem"
                  qtyField="SUBD_QTY"
                  display="oos"
                ></app-product-list>
                <div style="padding: 1rem 0;">
                  <h5 [ngSwitch]="orderSub.oldItem.MWG_UPC_NUM === ''">
                    <div *ngSwitchCase="true">We found...</div>
                    <div *ngSwitchDefault>Would you like...</div>
                  </h5>
                </div>
                <app-product-list
                  [item]="orderSub.newItem"
                  qtyField="SHOPPED_QTY"
                  display="sub"
                  [subbedItem]="orderSub.oldItem"
                ></app-product-list>
                <div class="columns is-mobile" style="margin-top: 1rem;">
                  <div class="column">
                    <a
                      class="button full-width"
                      [ngClass]="{
                        'is-outlined': orderSub.isSubApproved === '',
                        'is-danger': orderSub.isSubApproved === 'N'
                      }"
                      (click)="reject(orderSub)"
                    >
                      <span>No Thanks</span>
                    </a>
                  </div>
                  <div class="column">
                    <a
                      class="button full-width"
                      [ngClass]="{
                        'is-outlined': orderSub.isSubApproved === '',
                        'is-success': orderSub.isSubApproved === 'Y'
                      }"
                      (click)="approve(orderSub)"
                    >
                      <span>Yes</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- List Customer Backup Subs -->
          <div class="column is-12-mobile is-6-tablet" *ngIf="retailStore.isCustomerChoiceEnabled && backupSubs.length > 0">
            <app-customers-choice 
              [choices]="backupSubs"
              [verbiage]="'Your chosen replacement was not available. Would you like...'"
              [choiceOOS]="true"
              (emitterOfAcceptance)="receiveAcceptData($event)"
              (emitterOfRejection)="receiveRejectData($event)"
            ></app-customers-choice>
          </div>
          <!-- List Customer Choice Subs -->
          <div class="column is-12-mobile is-6-tablet" *ngIf="retailStore.isCustomerChoiceEnabled && custSubs.length > 0">
            <app-customers-choice 
              [choices]="custSubs"
              [verbiage]="'We were able to find your chosen replacement...'"
              [choiceOOS]="false"
              (emitterOfAcceptance)="receiveAcceptData($event)"
              (emitterOfRejection)="receiveRejectData($event)"
            ></app-customers-choice>
          </div>
        </div>
      </div>
      <!-- Addons -->
      <!--
      <div
        class="column is-12-mobile is-10-tablet is-offset-1-tablet"
        style="margin-top: 1.5rem;"
        *ngIf="orderAddonItems.length > 0"
      >
        <app-order-addon-item-list [list]="orderAddonItems">
        </app-order-addon-item-list>
      </div>
      -->
      <!-- Out of Stocks -->
      <div
        class="column is-12-mobile is-10-tablet is-offset-1-tablet"
        style="margin-top: 1.5rem;"
        *ngIf="orderOutOfStocks.length > 0"
      >
        <app-order-out-of-stock-list [list]="orderOutOfStocks">
        </app-order-out-of-stock-list>
      </div>
      <!-- Done -->
      <div
        class="column is-12-mobile is-6-tablet is-offset-one-quarter-tablet has-text-centered"
        style="margin-top: 3rem;"
      >
        <a
          class="button is-info is-medium elevation-1 full-width"
          (click)="submit()"
          >Done</a
        >
      </div>
    </div>
  </div>
</section>

<!-- Approval Modal -->
<div class="modal modal-full" [ngClass]="{ 'is-active': isActive }">
  <div class="modal-background" (click)="hideModal()"></div>
  <div class="modal-content">
    <div class="box">
      <ng-container *ngIf="approvedAllSubs && approvedAllSubs.length > 0">
        <h5 class="title is-size-5">Accepted Sustitutions</h5>
        <div class="completed-list" style="margin-bottom: 2rem;">
          <article class="media" *ngFor="let x of approvedAllSubs">
            <div class="media-content">
              <div class="content">
                <p>
                  {{ x.newItem.MWG_BRND_NAME }}
                  {{ x.newItem.MWG_PRODCT_NAME }}
                </p>
              </div>
            </div>
            <span class="media-right"> qty {{ x.newItem.SHOPPED_QTY }} </span>
          </article>
        </div>
        <div class="columns is-mobile">
          <div class="column">
            <a
              class="button is-info full-width"
              (click)="finish()"
              [ngClass]="{ 'is-loading': isLoading }"
              >Submit</a
            >
          </div>
          <div class="column">
            <a class="button is-light full-width" (click)="hideModal()"
              >Go Back</a
            >
          </div>
        </div>
      </ng-container>
        <ng-container *ngIf="!approvedAllSubs || approvedAllSubs.length < 1">
          <div class="completed-list" style="margin-bottom: 2rem;">
            <h5 class="title is-size-5">
              You've chosen to decline all substitutions. Are you sure?
            </h5>
          </div>
          <div class="columns is-mobile">
            <div class="column">
              <a
                class="button is-info full-width"
                (click)="finish()"
                [ngClass]="{ 'is-loading': isLoading }"
                >Yes</a
              >
            </div>
            <div class="column">
              <a class="button is-light full-width" (click)="hideModal()">No</a>
            </div>
          </div>
        </ng-container>
    </div>
  </div>
  <button
    class="modal-close is-large"
    (click)="hideModal()"
    aria-label="close"
  ></button>
</div>
